import { createBotsSlice } from 'src/store/shared/tradingBots/factory';
import { createSession, sendMessageWs } from 'src/store/shared/tradingBots/actions';
import {
  selectorTradingLastMessageId,
  selectorTradingSessionDetails,
} from 'src/store/loans/bots/selectors';
import { actionOnMessage } from '@skynet/data-ws-mm';
import type { TradingState } from 'src/store/shared/tradingBots/types';
import { sendMessageAction } from 'src/store/shared/tradingBots/factoryActions';

const sendMessage = sendMessageAction({
  prefix: 'loans',
  selectorTradingSessionDetails,
  selectorTradingLastMessageId,
  sendMessage: sendMessageWs,
});

export const initialState: TradingState = {
  error: null,
  groupList: null,
  groupListStatus: null,
  messageStatus: null,
  messageLog: [],
  sessionCreateStatus: null,
  sessionDetails: null,
};

const slice = createBotsSlice({
  prefix: 'loans',
  sendMessage: sendMessageWs,
  createSession,
  onMessage: actionOnMessage,
  initialState,
});

export const loansBotActions = { ...slice.actions, sendMessage, createSession };

export default slice.reducer;
